import { createFileRoute } from '@tanstack/react-router';
import { taskListQuery } from '../../api/tasks.ts';
import type { FilterPatch } from '../../features/tasks/task-filters.tsx';
import { TaskListPage } from '../../features/tasks/task-list-page.tsx';
import {
  listParamsOf,
  validateTaskSearch,
  type TaskSearch,
} from '../../features/tasks/task-search.ts';

// Tasks list (T20). Filters are search params: every change is a new history entry, so Back
// returns to the previous filters (constitution §5.6).
export const Route = createFileRoute('/_authed/tasks/')({
  validateSearch: validateTaskSearch,
  loaderDeps: ({ search }) => search,
  // Start the request while the page code loads; the page shows its own loading and errors.
  loader: ({ context, deps }) => {
    void context.queryClient.prefetchQuery(taskListQuery(listParamsOf(deps)));
  },
  component: TasksRoute,
});

function TasksRoute(): React.JSX.Element {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const onSearch = (patch: FilterPatch, opts: { readonly keepPage?: boolean } = {}): void => {
    void navigate({
      // The patch holds raw form values; the same check as the URL turns them into filters.
      search: (prev: TaskSearch) =>
        validateTaskSearch({
          ...prev,
          ...patch,
          ...(opts.keepPage === true ? {} : { page: undefined }),
        }),
    });
  };
  return <TaskListPage search={search} onSearch={onSearch} />;
}
